const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i

export function isValidUuid(value: string): boolean {
  return uuidPattern.test(value)
}

export function getEventKey(userId: number, eventId: string): string {
  return `${userId}.${eventId}`
}
